import { ResourceType } from "@core/shared/types";

export function useInlineDisplayable() {
  const isInlineDisplayable = (type: ResourceType) => {
    return [
      ResourceType.Pdf,
      ResourceType.Image,
      ResourceType.Video,
      ResourceType.Youtube,
      ResourceType.Assessment,
    ].includes(type);
  };

  return {
    isInlineDisplayable,
  };
}
